import React from 'react';
import { CheckCircleIcon } from 'lucide-react';
export function SEOContentSection() {
  return <section className="py-16 bg-white border-t border-gray-200" data-id="element-933" data-mp="tvo7ogvfucwf">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-934" data-mp="tttlz0ccegra">
        <div className="prose prose-lg prose-navy max-w-none" data-id="element-935" data-mp="yo7jp9eh8zz4">
          <h2 className="text-3xl font-bold text-navy mb-6 text-center" style={{
          color: "#6659B0"
        }} data-id="element-936" data-mp="13mivhpoc1kjz">
            Why Choose an Online Degree?
          </h2>

          <p className="text-gray-600 mb-8 text-center" data-id="element-937" data-mp="60brohzurw8o">
            Online education has transformed how adults achieve their academic
            and career goals. With flexible scheduling, lower overall costs, and
            the same rigorous curriculum as on-campus programs, earning your
            degree online is a smart investment in your future.
          </p>

          <div className="grid md:grid-cols-2 gap-8 mb-12" data-id="element-938" data-mp="1rasdshmc7q6d">
            <div className="bg-light p-6 rounded-xl border border-gray-100" data-id="element-939" data-mp="1waeq8oucd2e4">
              <h3 className="text-xl font-bold text-navy mb-3 flex items-center" data-id="element-940" data-mp="1wchrk50y2hy5">
                <CheckCircleIcon className="w-5 h-5 text-green-500 mr-2" data-id="element-941" data-mp="wyu1umpgo0ph" />
                Flexibility & Convenience
              </h3>
              <p className="text-sm text-gray-600" data-id="element-942" data-mp="nyoycnne1mgl">
                Study when and where it works for you. Online programs are
                designed for working professionals, allowing you to balance
                education with career and family responsibilities.
              </p>
            </div>
            <div className="bg-light p-6 rounded-xl border border-gray-100" data-id="element-943" data-mp="99izx1wdk09r">
              <h3 className="text-xl font-bold text-navy mb-3 flex items-center" data-id="element-944" data-mp="4axy4y1h58j7">
                <CheckCircleIcon className="w-5 h-5 text-green-500 mr-2" data-id="element-945" data-mp="48vc0p3fzzjr" />
                Career Advancement
              </h3>
              <p className="text-sm text-gray-600" data-id="element-946" data-mp="3rfe6ge2md48d">
                Employers increasingly value online degrees from accredited
                institutions. Gain the skills needed for promotions or career
                changes without leaving your current job.
              </p>
            </div>
          </div>

          <h2 className="text-2xl font-bold text-navy mb-4" data-id="element-947" data-mp="3hsl2ro6wvc6g">
            How Our Matching Service Works
          </h2>
          <p className="text-gray-600 mb-6" data-id="element-948" data-mp="32vu7nr49smmn">
            Finding the right school can be overwhelming. We simplify the
            process by connecting you with accredited institutions that match
            your specific needs:
          </p>

          <ol className="space-y-4 mb-8 text-gray-600" data-id="element-949" data-mp="3vlst7cj9a1mk">
            <li className="flex items-start" data-id="element-950" data-mp="4bu3ovnnr4nd">
              <span className="flex items-center justify-center w-8 h-8 rounded-full bg-cta text-white font-bold text-sm mr-4 flex-shrink-0" data-id="element-951" data-mp="3ltn2050tvo8f">
                1
              </span>
              <div data-id="element-952" data-mp="3qqn8gh1lat02">
                <strong className="text-navy block" data-id="element-953" data-mp="icwt9idv2x31">
                  Tell us about your goals
                </strong>
                Complete our short form to share your area of interest, current
                education level, and contact information.
              </div>
            </li>
            <li className="flex items-start" data-id="element-954" data-mp="22uyw1940yzos">
              <span className="flex items-center justify-center w-8 h-8 rounded-full bg-cta text-white font-bold text-sm mr-4 flex-shrink-0" data-id="element-955" data-mp="22txh2tjw1t1s">
                2
              </span>
              <div data-id="element-956" data-mp="2ckifogzkaxkp">
                <strong className="text-navy block" data-id="element-957" data-mp="2cm3be9xm4mk5">
                  Get matched instantly
                </strong>
                Our system filters through hundreds of accredited programs to
                find the ones that align with your criteria.
              </div>
            </li>
            <li className="flex items-start" data-id="element-958" data-mp="1xwxbskuv4ubq">
              <span className="flex items-center justify-center w-8 h-8 rounded-full bg-cta text-white font-bold text-sm mr-4 flex-shrink-0" data-id="element-959" data-mp="1xtjbdi5rev6x">
                3
              </span>
              <div data-id="element-960" data-mp="3997zicur209b">
                <strong className="text-navy block" data-id="element-961" data-mp="39cvtte80qqp3">Compare and enroll</strong>
                Receive information directly from the schools, compare your
                options, and take the next step toward your degree.
              </div>
            </li>
          </ol>
        </div>
      </div>
    </section>;
}